import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../styles/ProjectList.module.css";
import { Box, Link, Typography, Grid2, Stack } from "@mui/material";
import { TextField, InputAdornment, Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
} from "@mui/material";
import ProjectModal from "../components/EditProjectModal";
import editLogo from "../assets/EditIcon.svg";
import deleteLogo from "../assets/delete.svg";
import useOutsideClick from "../hooks/useOutsideClick";
import Popup from 'reactjs-popup';
import ExcelExport from "./Partials/ExcelExport";
import { useGetAllProjectsQuery, useDeleteProjectMutation } from '../store/slices/apis/projectApiSlice';
import { closeSnackbar, openSnackbar } from '../store/slices/snackbar';
import { useDispatch } from '../store';
import { Skeleton } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { ReactComponent as AddNewIcon } from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as MoreHorizontalIcon } from "assets/PwC_Funct_Icons_MoreHorizontal_Outline_Black_RGB.svg"
import { useRedirectFromProjects } from "hooks/useRedirectFromProjects";
import { useAuth } from "context/AuthContext";
import { useLazyGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";


const ProjectList = () => {

  const theme = useTheme();
  const dispatch = useDispatch();
  
  const { getProjectPermissionInfo, setUser, user } = useAuth();
  const { data: AllProjects = [], isLoading, error, refetch } = useGetAllProjectsQuery();
  const [deleteProject, { isLoading: isDeleting, error: deleteError }] = useDeleteProjectMutation();


  const [sortType, setSortType] = useState('');
  const [style, setStyle] = useState(0);


  useEffect(() => {
    const sortArray = type => {
      if (style !== 0)
        setStyle(0);
      else
        setStyle(1);
      const types = {
        budgeted_cost: 'budgeted_cost',
        invoiced_cost: 'invoiced_cost',
        end_date: 'end_date',
      };
      const sortProperty = types[type];
      //const sorted = [...AllProjects].sort((a, b) => {return style ? b[sortProperty] - a[sortProperty] : a[sortProperty] - b[sortProperty]});
      //setProjects(sorted);
    };

    sortArray(sortType);
  }, [sortType]);


  const inputRef = useRef();
  const navigate = useNavigate();
  const [projects, setProjects] = useState(AllProjects);
  const [openOptions, setOpenOptions] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { projectId } = useParams();
  const handleClick = useRedirectFromProjects();

  const [projectPermissionFun, projectPermissionRes] = useLazyGetProjectPermissionQuery();

  const [isOpen, setIsOpen] = useState(false);

  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);

  useOutsideClick(inputRef, () => setOpenOptions(null));

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const handleGetProjectPermission = async (projectVal) => {
    await projectPermissionFun({ projectId: projectVal?.project_id })
    // handleClick(projectVal)
  }

  useEffect(() => {
    if (projectPermissionRes?.isSuccess) {
      if (projectPermissionRes?.data?.status == 'success') {
        setUser({
          ...user,
          permission: projectPermissionRes?.data?.result?.modules
        });
        handleClick(projectPermissionRes?.originalArgs?.projectId, projectPermissionRes?.data?.result?.modules);
      }
    }
  }, [projectPermissionRes?.isSuccess])


  const filteredProjects = AllProjects?.data?.filter((proval) => {
    const query = searchQuery.toLowerCase();
    if (proval.active === true) {
      return (
        proval.project_name.toLowerCase().includes(query) ||
        proval.project_manager_name.toLowerCase().includes(query) ||
        proval.project_manager_email.toLowerCase().includes(query)
      );
    }
  });

  filteredProjects?.sort((a, b) => {
    if (new Date(a.createddate) < new Date(b.createddate)) {
      return 1;
    }
    return -1;
  });

  const toggleOptions = (index) => {
    setOpenOptions(openOptions === index ? null : index);
  };

  const handleOpenModal = (user = null) => {
    setSelectedUser(user);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedUser(null);
  };

  const handleSaveUser = (userData) => {
    if (selectedUser) {
      setProjects(
        projects.map((user) => (user.id === selectedUser.id ? userData : user))
      );
    } else {
      setProjects([...projects, userData]);
    }
    handleCloseModal();
  };

  const addProject = () => {
    navigate("/projects/project-creation/addproject");
  };

  useEffect(() => {
    if (refetch) refetch()
  }, [refetch])

  const openNotification = async (msg, type = 'error') => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: 'alert',
        alert: {
          color: type
        },
        close: false
      })
    );
    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  // const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

  // const handleRedirectProject = (val) => {
  //   const projectPage = tabs?.filter(item => hasPermission(item?.permissionKey) > 0);
  //   if (projectPage?.length > 0) {
  //     navigate(`/projects/${val?.project_id}?type=${projectPage?.[0]?.path}`)
  //     localStorage.setItem('projectUrl', encrypt(projectPage?.[0]?.path));
  //   } else {
  //     navigate(`/projects/${val?.project_id}/my-work`);
  //   }
  // }

  const handleDeleteProject = async (id) => {
    try {
      const response = await deleteProject(id).unwrap();
      if (response?.status == 'success') {
        openNotification(response?.message, 'success');
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
      else {
        openNotification(response?.message);
      }

    } catch (error) {
      openNotification(error?.message);
    }
  }

  // ongoing and completed project's count
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  let todayDate = yyyy + '-' + mm + '-' + dd;

  const filter1 = filteredProjects?.filter(function (obj) { return (todayDate > obj?.start_date?.slice(0, 10) && todayDate < obj?.end_date?.slice(0, 10)) });
  const ongoing = filter1?.length;

  const filter2 = filteredProjects?.filter(function (obj) { return todayDate >= obj?.end_date?.slice(0, 10) });
  const completed = filter2?.length;
  // ongoing and completed project's count

  function dateFormat(string) {
    const [date, time] = string.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  if (isLoading) return <Skeleton />

  return (
    <Box sx={{ width: "100%" }}>
      {/* <Header /> */}
      <div className={styles.main}>
        <div className={styles.content} style={{ padding: 0 }}>
          <div className={styles.mrlftp} style={{ marginLeft: 0, marginTop: '40px' }}>
            <Grid2 container spacing={1}>
              <Grid2 size={12}>
                <div className={styles.infoTag}>All Projects</div>
              </Grid2>
              <Grid2 size={12}>
                <div className={styles.top}>
                  <div className={styles.topLeft}>

                    <div className={styles.info}>
                      <Stack spacing={2} direction="row">
                        <Button
                          variant="contained"
                          onClick={() => addProject()}

                          sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            color: '#FFF',
                            padding: '6px 20px',
                            fontWeight: '500',
                            textTransform: 'none',
                            fontSize: '16px',
                            whiteSpace: "nowrap",
                            gap: '8px',
                          }}
                        >
                          <div
                            className={styles.plusIcon}
                          >
                            <AddNewIcon
                              style={{
                                fill: theme?.customSettings?.themeColor,
                                width: "16px",
                                height: "16px",
                                stroke: theme?.customSettings?.themeColor,
                                strokeWidth: 6
                              }}
                            />
                          </div>

                          New Project
                        </Button>

                        <ProjectModal
                          open={openModal}
                          handleClose={handleCloseModal}
                          user={selectedUser}
                        //onSubmit={handleSaveUser}
                        />
                        {/* <div onClick={() => openNotification('File Exported successfully.', 'success')}> */}
                        <ExcelExport data={AllProjects.data} fileName="ProjectSample" />
                      </Stack>
                      {/* </div> */}
                    </div>



                    {/* <div>
                      <span style={{ fontSize: "16px", lineHeight: "24px", fontWeight: 400 }}>Sort by </span>

                      <button value="budgeted_cost" className={styles.btnsort}>
                        Budgeted Cost
                      </button>

                    </div> */}
                  </div>

                  <div className={styles.text}>
                    <span className={styles.texton} style={{ whiteSpace: 'nowrap' }}>Total {filteredProjects?.length} </span> <span className={styles.texton} style={{ whiteSpace: 'nowrap' }}>Ongoing {ongoing}</span>
                    <span className={styles.textcom} style={{ whiteSpace: 'nowrap', color: theme?.customSettings?.themeColor }}><span style={{ color: theme?.customSettings?.themeColor }}>&#x2714;</span> Completed {completed} </span>
                  </div>
                </div>
              </Grid2>
              <Grid2 size={12}>
                <div className={styles.list}>
                  <TextField
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search by project name or manager name"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ height: "20px", width: "20px", fill: "#808080 " }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton onClick={clearSearch} edge="end">
                          <CrossIcon style={{ fontSize: "16px", width: "16px", height: "16px", fill: "#808080 " }} />
                        </IconButton>
                      ),
                      style: {
                        fontSize: "16px",
                      },
                    }}
                    sx={{
                      width: "100%",
                      height: "48px",
                      background: "#fff",
                      "& .MuiInputBase-root": {
                        height: "48px",
                      },
                      "& .MuiInputBase-input": {
                        fontSize: "16px",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        fontSize: { xs: '14px', sm: "16px" },
                        fontWeight: "400",
                        color: "#696969",
                        opacity: 0.7,
                        lineHeight: "24px",
                        letterSpacing: "0.4px",
                      },
                      marginBottom: "4px",
                    }}
                  />

                  {filteredProjects && filteredProjects.length > 0 ? (
                    filteredProjects.map((projectval, index) => (
                      <TableContainer component={Paper} sx={{ marginTop: "6px", width: "100%" }}>
                        <Table>
                          <TableBody>
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  borderBottom: "none",
                                },
                              }}
                            >
                              <TableCell style={{ borderBottom: "none", width: "64%" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  {/* <div className={styles.userInitials}> */}
                                  <div style={{ display: "flex", gap: "10px" }}>
                                    <div className={styles.nameavatar}>
                                      {projectval.project_name.substring(0, 1).toUpperCase()}
                                    </div>
                                  </div>

                                  {/* </div> */}
                                  <div>
                                    {/* <div className={styles.name} style={{cursor:'pointer'}} onClick={() => {
                                    navigate(`/projects/${projectval?.project_id}?type=${DEFAULT_PROJECT_DASHBOARD}`)
                                  }}> */}
                                    <div className={styles.name} style={{ cursor: 'pointer' }} onClick={async () => {
                                      handleGetProjectPermission(projectval);
                                      // await getProjectPermissionInfo(projectval?.project_id)
                                      // handleClick(projectval);

                                    }}>
                                      {projectval.project_name}
                                    </div>
                                    <div className={styles.email}>Project Manager: {projectval.project_manager_name} ({projectval.project_manager_email})</div>
                                  </div>
                                </div>
                              </TableCell>

                              <TableCell style={{ borderBottom: "none", width: "9%" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <div>
                                    <div className={styles.name}>
                                      Budgeted Cost
                                    </div>
                                    <div className={styles.email}>₹{projectval.budgeted_cost} M</div>
                                  </div>
                                </div>
                              </TableCell>

                              <TableCell style={{ borderBottom: "none", width: "9%" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <div>
                                    <div className={styles.name}>
                                      Invoiced Cost
                                    </div>
                                    <div className={styles.email}>${projectval.invoiced_cost} M</div>
                                  </div>
                                </div>
                              </TableCell>

                              <TableCell style={{ borderBottom: "none", width: "7%" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <div>
                                    <div className={styles.name}>
                                      Start Date
                                    </div>
                                    <div className={styles.email}>{projectval.start_date ? dateFormat(projectval.start_date) : "NA"}</div>
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell style={{ borderBottom: "none", width: "7%" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <div>
                                    <div className={styles.name}>
                                      End Date
                                    </div>
                                    <div className={styles.email}>{projectval.end_date ? dateFormat(projectval.end_date) : "NA"}</div>
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell style={{ borderBottom: "none", width: "4%" }}>
                                <div className={styles.login}>

                                  <Popup trigger={
                                    <span className={styles.options}>
                                      <MoreHorizontalIcon onClick={openPopup} />
                                    </span>}>

                                    {isOpen && (
                                      <div
                                        className={styles.optionsContainer}

                                      >
                                        <div className={styles.createdAt}>
                                          Created: {projectval.createddate ? dateFormat(projectval.createddate) : "NA"}

                                          {/* <button className={styles.btnright} onClick={closePopup}><CloseIcon/></button> */}

                                        </div>
                                        <button
                                          className={styles.optionButton}
                                          onClick={() => {
                                            handleOpenModal(projectval);
                                            closePopup();
                                            //setOpenOptions(null);
                                          }}
                                        >
                                          <div className={styles.optionsLogo}>
                                            <img src={editLogo} alt="Edit" />
                                          </div>
                                          Edit Project Details
                                        </button>
                                        <button
                                          className={styles.optionButton}
                                          //onClick={() => 
                                          //setOpenOptions(null)}
                                          onClick={() => { handleDeleteProject(projectval.project_id); closePopup(); }}
                                        >
                                          <div className={styles.optionsLogo}>
                                            <img src={deleteLogo} alt="Delte" />
                                          </div>
                                          Delete Project
                                        </button>
                                      </div>
                                    )}
                                  </Popup>

                                </div>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ))
                  ) : (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              align="center"
                              sx={{
                                fontSize: "16px",
                                lineHeight: "20px",
                                fontWeight: 400,
                              }}
                            >
                              No Data Found
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </div>
              </Grid2>
            </Grid2>
          </div>
        </div>
      </div>
    </Box>
  )
}

export default ProjectList;